export const BOOZE_LIMITS: number[] = [
  0, 0, 0, 1, 2, 2, 3, 5, 8, 10, 12, 15, 18, 20, 25, 30, 35, 40, 40, 40, 40, 40,
  40, 40, 40, 40, 40, 40, 40, 40,
];

export const NARCS_LIMITS: number[] = [
  0, 0, 0, 0, 0, 1, 1, 2, 3, 5, 6, 7, 9, 10, 12, 15, 17, 20, 20, 20, 20, 20, 20,
  20, 20, 20, 20, 20, 20, 20,
];
